module.exports = __webpack_public_path__ + "static/media/banner2v2.fca6fa23.png";